import { ArrowDown, ArrowUp, X } from 'lucide-react';
import { watchlistIconClass } from './watchlistEditor.utils';

interface WatchlistSymbolRowProps {
  ticker: string;
  label: string | null;
  index: number;
  symbolCount: number;
  isMutating: boolean;
  onMove: (from: number, to: number) => void;
  onRemove: () => void;
}

export function WatchlistSymbolRow({
  ticker,
  label,
  index,
  symbolCount,
  isMutating,
  onMove,
  onRemove,
}: WatchlistSymbolRowProps) {
  return (
    <div className="flex min-h-10 items-center gap-2 border-b border-zinc-900 px-3 last:border-b-0">
      <span className="w-14 font-mono text-[10px] font-semibold">{ticker}</span>
      <span className="min-w-0 flex-1 truncate font-mono text-[10px] text-zinc-500">
        {label ?? 'No longer available'}
      </span>
      {label == null && (
        <span className="font-mono text-[9px] uppercase text-amber-500">Unavailable</span>
      )}
      <OrderButton
        label={`Move ${ticker} up`}
        disabled={isMutating || index === 0}
        direction="up"
        onClick={() => onMove(index, index - 1)}
      />
      <OrderButton
        label={`Move ${ticker} down`}
        disabled={isMutating || index === symbolCount - 1}
        direction="down"
        onClick={() => onMove(index, index + 1)}
      />
      <button
        type="button"
        aria-label={`Remove ${ticker}`}
        disabled={isMutating}
        onClick={onRemove}
        className={watchlistIconClass}
      >
        <X className="h-3.5 w-3.5" />
      </button>
    </div>
  );
}

function OrderButton({
  label,
  direction,
  disabled,
  onClick,
}: {
  label: string;
  direction: 'up' | 'down';
  disabled: boolean;
  onClick: () => void;
}) {
  const Icon = direction === 'up' ? ArrowUp : ArrowDown;
  return (
    <button
      type="button"
      aria-label={label}
      disabled={disabled}
      onClick={onClick}
      className={watchlistIconClass}
    >
      <Icon className="h-3 w-3" />
    </button>
  );
}
